var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseRed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8633 11.1172C13.3516 11.6055 13.3516 12.3965 12.8633 12.8848C12.6211 13.1289 12.3008 13.25 11.9805 13.25C11.6602 13.25 11.3406 13.1279 11.0969 12.8838L6.98047 8.76953L2.86445 12.8828C2.62031 13.1289 2.30039 13.25 1.98047 13.25C1.66055 13.25 1.34102 13.1289 1.09668 12.8828C0.608398 12.3945 0.608398 11.6035 1.09668 11.1152L5.21387 6.99805L1.09668 2.88281C0.608398 2.39453 0.608398 1.60352 1.09668 1.11523C1.58496 0.626953 2.37598 0.626953 2.86426 1.11523L6.98047 5.23438L11.0977 1.11719C11.5859 0.628906 12.377 0.628906 12.8652 1.11719C13.3535 1.60547 13.3535 2.39648 12.8652 2.88477L8.74805 7.00195L12.8633 11.1172Z",
    fill: "#E53451"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseRed);
export default __webpack_public_path__ + "static/media/close-red.3c7d1e4ec520554f9f957d53e3c79124.svg";
export { ForwardRef as ReactComponent };